import React from 'react';
import './Footer.scss';

const Footer = () => {
	return (
		<footer className='Footer' name='Footer'>
			<p>@ 2020 Shyam Chaudhary / Theme & Design by <a href="https://github.com/bchiang7">bchiang7</a></p>
		</footer>
	);
};

export default Footer;
